import { render, staticRenderFns } from "./bulkUploadsUtils.vue?vue&type=template&id=0bff9178&scoped=true"
import script from "./bulkUploadsUtils.vue?vue&type=script&lang=js"
export * from "./bulkUploadsUtils.vue?vue&type=script&lang=js"
import style0 from "./bulkUploadsUtils.vue?vue&type=style&index=0&id=0bff9178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bff9178",
  null
  
)

export default component.exports